// extracted by mini-css-extract-plugin
module.exports = {"questionMark":"group_tooltip-module_questionMark_ea92f"};